const inventoryRoutes = [
    {
        path: '/abnormalInventoryOrders',
        name: 'abnormalInventoryOrders',
        component: () => import('../../views/inventory/AbnormalInventoryOrders.vue'),
        meta: { title: '异常订单' }
    },
    {
        path: '/binLocationManagement',
        name: 'binLocationManagement',
        component: () => import('../../views/inventory/BinLocationManagement.vue'),
        meta: { title: '库位管理' }
    },
    {
        path: '/inventoryList',
        name: 'inventoryList',
        component: () => import('../../views/inventory/InventoryList.vue'),
        meta: { title: '库存列表' }
    },
    {
        path: '/splitMerge',
        name: 'splitMerge',
        component: () => import('../../views/inventory/SplitMerge.vue'),
        meta: { title: '拆单/合单' }
    },
    {
        path: '/splitMergeRecords',
        name: 'splitMergeRecords',
        component: () => import('../../views/inventory/SplitMergeRecords.vue'),
        meta: { title: '拆单/合单记录' }
    },
    {
        path: '/warehouseInfoManagement',
        name: 'warehouseInfoManagement',
        component: () => import('../../views/inventory/WarehouseInfoManagement.vue'),
        meta: { title: '仓库信息管理' }
    },
    {
        path: '/waitingServiceList',
        name: 'waitingServiceList',
        component: () => import('../../views/inventory/WaitingServiceList.vue'),
        meta: { title: '待服务列表' }
    }
]

export default inventoryRoutes

